export { default } from "./PaySlicer"
